<div class="spa-autocomplete-search">
  <div class="spa-autocomplete-search-input-container" data-testid="search_field" [class.searching]="isSearching">
    <dx-text-input
      id="guest-input-search"
      placeholder="{{ 'placeholder.enter-at-least-3-chars' | transloco }}"
      [icon]="icon()"
      [label]="label()"
      [readonly]="isReadOnly()"
      [required]="isRequired"
      [value]="searchTerm()"
      (enterPress)="enterpressed()"
      (focus)="onFocus()"
      (valueChange)="onInputChange($event)"
    >
    </dx-text-input>
    <dx-loading-indicator class="pr-2" size="medium" theme="light"></dx-loading-indicator>
  </div>

  @if (localRows(); as rows) {
    <div class="spa-autocomplete-search-autocomplete-container" tabindex="0">
      @if (rows.length) {
        <div class="spa-autocomplete-search-results-container">
          @for (row of rows; track row; let i = $index) {
            <div class="spa-autocomplete-search-results-row" data-testid="search_result">
              @if (checkboxSelectionType !== "none") {
                <dx-checkbox
                  (checkedChange)="onCheck(i)"
                  [checked]="row.isChecked"
                  [readonly]="row.alreadySelected"
                  [templatevalue]="null"
                  class="pr-3"
                  id="checkbox-{{ i }}"
                  data-testid="search_result_selected_checkbox"
                ></dx-checkbox>
              }
              <div
                (click)="onSelectSingleRowDirectly(row)"
                [ngStyle]="{ cursor: row.alreadySelected ? 'default' : 'pointer' }"
                class="spa-autocomplete-search-guest-container"
              >
                @for (column of columns; track column; let j = $index) {
                  <div
                    class="spa-autocomplete-search-cell pr-3"
                    id="autocomplete-cell-{{ i }}-{{ j }}"
                    [ngStyle]="{
                      width: column.widthInPercent ?? column.widthInPercent,
                    }"
                    lang="de"
                  >
                    {{ cellValue(row.data, column) }}
                    @if (getTemplate(column.key); as tpl) {
                      <ng-container *ngTemplateOutlet="tpl.template; context: { row }"></ng-container>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
        @if (checkboxSelectionType !== "none") {
          <div class="spa-autocomplete-search-buttons">
            <spa-button
              (clickedButton)="reset()"
              class="mr-3"
              id="search-box-btn-cancel"
              label="{{ 'label.button.cancel' | transloco }}"
              shape="link"
            ></spa-button>
            <spa-button
              class="ml-3"
              id="search-box-btn-confirm"
              [disabled]="applyDisabled()"
              [label]="'label.button.ok' | transloco"
              (clickedButton)="applySelection()"
            ></spa-button>
          </div>
        }
      } @else {
        @if (!rows.length) {
          <div class="spa-autocomplete-search-no-results">
            {{ "empty-search-text.home.search" | transloco }}
          </div>
        }
      }
    </div>
  }
</div>
